import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-ak-accent mb-4">404</h1>
        <h2 className="text-3xl font-bold text-white mb-4">Seite nicht gefunden</h2>
        <p className="text-ak-muted mb-8 max-w-md mx-auto">
          Die gesuchte Seite existiert leider nicht. Vielleicht haben Sie sich in der URL vertippt?
        </p>
        <Link to="/" className="btn-primary">
          <i className="pi pi-home mr-2"></i>
          Zur Startseite
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
